import {
  LauncherIconCustomLink,
  LauncherLaunchLink,
  LauncherLink,
  LauncherSocialLink,
} from "@store-platform/types"
import { LaunchLinkAction, LaunchLinkLabel, SocialLinkLabel } from "./config"
import { getLinkIconId } from "./icon.helpers"

export function launchLink(link: LauncherLaunchLink): LauncherLink {
  return {
    label: LaunchLinkLabel[link.type],
    url: link.url,
    iconId: getLinkIconId("launch", link.type),
    action: LaunchLinkAction[link.type],
  }
}

export function socialLink(link: LauncherSocialLink): LauncherLink {
  return {
    label: SocialLinkLabel[link.type],
    url: link.url,
    iconId: getLinkIconId("social", link.type),
  }
}

export function webLink(link: LauncherIconCustomLink): LauncherLink {
  return {
    label: link.label,
    url: link.url,
    iconId: getLinkIconId("custom", link.icon),
  }
}
